import { Button, ButtonProps } from '../button/button';
import { InlineSvg } from 'components/svg';

export type SearchButtonProps = Omit<ButtonProps, 'icon' | 'iconPosition'>;

export const SearchButton = ({ text = 'Search', variant = 'danger', size = 'sm', ...rest }: SearchButtonProps) => (
  <Button
    text={text}
    variant={variant}
    size={size}
    icon={<InlineSvg path="/media/svg/general/magnifier.svg" className="svg-icon-3" />}
    iconPosition="left"
    {...rest}
  />
);
